import { useIntl } from 'react-intl'

/**
 * Returns a localized label like:
 * - "Session 1"
 * - "Sessions 2 and 3"
 * - "Sessions 1, 2, and 4"
 */
export const useSessionsLabel = (nums?: number[]): string => {
  const intl = useIntl()
  if (!nums || nums.length === 0) return ''

  const sorted = [...nums].sort((a, b) => a - b)
  const isPlural = sorted.length > 1

  const prefix = isPlural
    ? intl.formatMessage({ defaultMessage: 'Sessions', description: 'plural sessions noun' })
    : intl.formatMessage({ defaultMessage: 'Session', description: 'singular session noun' })

  if (sorted.length === 1) return `${prefix} ${sorted[0]}`
  if (sorted.length === 2) return `${prefix} ${sorted[0]} and ${sorted[1]}`
  return `${prefix} ${sorted.slice(0, -1).join(', ')}, and ${sorted[sorted.length - 1]}`
}
